/**
 * Sonner-backed shim around the toast API. Components call `useToast()` /
 * `useErrorToast()` to keep the call sites stable; underneath it's just
 * `toast()` from sonner. The hooks return memoized callbacks so they're
 * safe to depend on in `useEffect`.
 */

import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';

interface ToastApi {
  push: (text: string) => void;
  error: (text: string) => void;
  success: (text: string) => void;
}

export function useToast(): ToastApi {
  return useMemo<ToastApi>(
    () => ({
      push: (t) => toast(t),
      error: (t) => toast.error(t),
      success: (t) => toast.success(t),
    }),
    [],
  );
}

export function useErrorToast(): (e: unknown) => void {
  return useCallback((e: unknown) => {
    const msg = e instanceof Error ? e.message : String(e);
    toast.error(msg);
  }, []);
}
